module.exports = __webpack_public_path__ + "static/media/isabelle_ stuessi_mood.f1f7270d.jpg";